const MethodCelleTypes = {
    "disabled": "disabled",
    "default": "default",
    "highlighted": "highlighted",
    "error": "error",
    "success": "success"
};
var method_cell = Object.freeze(MethodCelleTypes);

export { method_cell as default };
//# sourceMappingURL=method_cell.js.map
